import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../../providers'

const initialOtpState = {
    status: 'idle',
    error: '',
}

const validateOtpField = (otp) => {
    if (otp.otp.length < 6) {
        return 'Please enter 6 digit OTP'
    }
    return 'valid'
}

const useOtp = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { phoneNumber, loginByOtp, registerByOtp } = useAuth()

    const [otpState, setOtpState] = useState(initialOtpState)
    const { status, error } = otpState

    const [otp, setOtp] = useState({ otp: '' })

    const handleChange = (otp) => setOtp({ otp })

    const comingFrom = location?.state?.from

    const handleOTPSubmit = async () => {
        if (!phoneNumber) {
            
            if (comingFrom === '/login') {
                return navigate('/login')
            }

            if (comingFrom === '/register') {
                return navigate('/register')
            }
        }

        setOtpState((prev) => ({ ...prev, error: '' }))

        const result = validateOtpField(otp)

        if (result === 'valid') {
            const formattedPhoneNumber = `+91${phoneNumber}`

            setOtpState((prevValues) => ({
                ...prevValues,
                status: 'loading',
            }))

            let res

            if (comingFrom === '/register') {
                res = await registerByOtp(formattedPhoneNumber, otp.otp)
            }

            if (comingFrom === '/login') {
                res = await loginByOtp(formattedPhoneNumber, otp.otp)
            }

            if (res?.data?.success) {
                setOtpState((prevValues) => ({
                    ...prevValues,
                    status: 'success',
                }))
                return
            }

            if(res?.data?.success === false){
                setOtp({otp:''})
            }

            setOtpState((prevValues) => ({
                ...prevValues,
                otp: '',
                status: 'failed',
                error: res?.data?.error,
            }))
            return
        }

        setOtpState((prev) => ({ ...prev, error: result }))
    }

    useEffect(() => {
        if (!phoneNumber) {
            if (comingFrom === '/login') {
                return navigate('/login')
            }

            if (comingFrom === '/register') {
                return navigate('/register')
            }
        }
        if (status === 'success') {
            setOtpState((prevValues) => ({
                ...prevValues,
                status: 'idle',
            }))
        }
    }, [status, navigate, phoneNumber, comingFrom])

    return {
        status,
        error,
        otp,
        handleChange,
        handleOTPSubmit,
        setOtp,
    }
}

export default useOtp
